import React from 'react';

import { IconName } from '@fortawesome/fontawesome-svg-core';
import styled from 'styled-components';

import Icon from '@/ui/components/Icon';

const MAP_TYPE_TO_ICON = {
  'tip-callout': 'info-circle',
  'warning-callout': 'exclamation-circle',
  'note-callout': 'comment',
  'success-callout': 'check-circle',
} satisfies { [key: string]: IconName };

const MAP_TYPE_TO_STYLE = {
  'tip-callout': {
    bgColor: 'rgba(13, 182, 250, 0.25)',
    borderColor: 'rgba(5, 176, 245, 0.25)',
    iconColor: 'rgb(13, 182, 250)',
  },
  'warning-callout': {
    bgColor: 'rgba(255, 0, 0, 0.25)',
    borderColor: 'rgba(242, 0, 0, 0.25)',
    iconColor: 'rgb(255, 0, 0)',
  },
  'note-callout': {
    bgColor: 'rgba(255, 197, 0, 0.25)',
    borderColor: 'rgba(242, 187, 0, 0.25)',
    iconColor: 'rgb(255, 197, 0)',
  },
  'success-callout': {
    bgColor: 'rgb(20,250,72, 0.25)',
    borderColor: 'rgba(75,181,67, 0.25)',
    iconColor: 'rgb(75,181,67)',
  },
};

export const Wrapper = styled.div<{ type: string; margin: string | undefined }>`
  display: block;
  color: #4b4c50;
  background-color: ${({ type }) => MAP_TYPE_TO_STYLE[type]?.bgColor || 'white'};
  border: 0 solid ${({ type }) => MAP_TYPE_TO_STYLE[type]?.borderColor || '#4b4c50'};
  border-left-width: 5px;
  border-radius: 2px;
  margin: ${({ margin }) => margin || '1em 1.5em'};
  padding: 1em 1em 1em 2.75em;
  position: relative;
  line-height: 1.1;

  svg {
    color: ${({ type }) => MAP_TYPE_TO_STYLE[type]?.iconColor || '#4b4c50'};
    position: absolute;
    left: 12px;
    width: 1.2rem;
    ${({ type }) =>
      type === 'warning-callout' &&
      `
      -webkit-animation: fa-beat 1s infinite linear;
      animation: fa-beat 1s infinite linear;
    `}
  }
`;

interface CalloutProps {
  type: 'tip-callout' | 'warning-callout' | 'note-callout' | 'success-callout';
  // icon?: string;
  children: React.ReactNode;
  margin?: string;
  className?: string;
}

export default function Callout({
  type = 'warning-callout',
  // icon = null,
  children,
  margin,
  className,
}: CalloutProps) {
  return (
    <Wrapper type={type} margin={margin} className={className || `${type}`}>
      <Icon name={MAP_TYPE_TO_ICON[type] || 'comment'} style="solid" size="lg" />
      {children}
    </Wrapper>
  );
}
